<template>

    <span>
    <v-layout mb-4>
      <v-flex xs10 ml-3>
        <h2 class="lime--text lighten-1 pt-3">Gerenciar Funcionários - Inclusão</h2>
      </v-flex>
      <v-flex xs2 text-right>
        <v-btn
          color="blue-grey"
          class="black--text"
          :to="{name: 'employees'}"
        >
          <v-icon dark>keyboard_arrow_left</v-icon>
          Voltar
        </v-btn>
      </v-flex>
    </v-layout>
        <form-employee :btnLabel="btnLabel"></form-employee>
    </span>
        
</template>

<script>
import FormEmployeeComponent from "./partial/FormEmployeeComponent";

export default {
  name: "AddEmployeeComponent",
  data () {
    return {
        btnLabel: 'Incluir'
    }
  },
  methods: {

  },
  components: {
    formEmployee: FormEmployeeComponent,
  }
};
</script>

<style scoped>

</style>
